import React from 'react'
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
function MobileAddMember() {
    const navigate = useNavigate();
  return (
    <div>
    <div className='mainWrapperView'>
     <div className='marginHorizontalCommon'>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/MobileGroup")}
        />
        <h1>Add Members</h1>
      </div>
      <div className='topSpace'></div>
      <div className='SearchSortDivTab'>
        <input type='text' placeholder='Search' />
      </div>
      <div className="famDetailsListInrMob">
        <div className='GroupMemberList'>
            <p>Member Name</p>
            <input type='checkbox' className='checkBoxStyle' />
        </div>
      </div>
      <div className="famDetailsListInrMob">
        <div className='GroupMemberList'>
            <p>Member Name</p>
            <input type='checkbox' className='checkBoxStyle' />
        </div>
      </div>
      <div className="famDetailsListInrMob">
        <div className='GroupMemberList'>
            <p>Member Name</p>
            <input type='checkbox' className='checkBoxStyle' />
        </div>
      </div>
      <div className="famDetailsListInrMob">
        <div className='GroupMemberList'>
            <p>Member Name</p>
            <input type='checkbox' className='checkBoxStyle' />
        </div>
      </div>
      </div>
      <div className='bottomBtnView'>
        <button className='submitButton'>Add Members</button>
      </div>
    </div>
    </div>
  )
}

export default MobileAddMember